/**
 * Development override configuration
 * Set narrativeKey to jump directly to a specific part of the demo
 * Set to null for normal flow starting from IntroSplash
 *
 * Available narrative keys:
 * - null: Start from IntroSplash
 * - "bracket.intro": Tournament bracket intro
 * - "bracket.liquidity": Liquidity explanation
 * - "bracket.ready": Ready for battle
 * - "finals.start": Battle screen start
 * - "finals.betting": Betting phase
 * - "finals.rally": Rally phase
 * - "finals.victory": Victory sequence
 * - "reveal.cta": Final CTA screen
 */

export const DEV_CONFIG = {
  // Set this to jump to a specific narrative key, or null for normal flow
  // narrativeKey: "intro.line1" as string | null,
  // narrativeKey: "bracket.liquidity" as string | null,
  // narrativeKey: "bracket.versus" as string | null,
  // narrativeKey: "finals.start" as string | null,
  // narrativeKey: "finals.rally" as string | null,
  // narrativeKey: "finals.victory" as string | null,
  // narrativeKey: "champion.winner" as string | null,
  narrativeKey: null as string | null,
};

// Helper to determine if we should skip intro based on dev config
export const shouldSkipIntro = () => {
  return (
    process.env.NODE_ENV === "development" && DEV_CONFIG.narrativeKey !== null
  );
};
